import React from "react";
import { Form, Input, Row, Select, Col, Typography } from "antd";

const { Text } = Typography;

const CurrencyForm = (props) => {
  const { onChange } = props;
  return (
    <Form
      layout="vertical"
      onFinish={props.onFinish}
      form={props.form}
      initialValues={props.initialValues}
      style={{ margin: 30 }}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Currency</Text>}
            name={"currencyCode"}
            rules={[{ required: true, message: "Required Field" }]}
          >
            <Select
              allowClear
              options={props.currencyData}
              placeholder="Please select a value"
              onChange={onChange}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Decimal Places</Text>}
            name={"digitsAfterDecimal"}
            rules={[{ required: true, message: "Required Field" }]}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Currency In Multiples Of</Text>}
            name={"inMultiplesOf"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Installment In Multiples Of</Text>}
            name={"installmentAmountInMultiplesOf"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CurrencyForm;
